export default __webpack_public_path__ + "static/media/funds.a74cc9a7.png";